<template>
  <div class="navi">
    <div class="body_container">
      <el-row justify='center' align='middle'>
        <a href="#/"><el-col class="logo-div" :span="4"><img class="logo" :src="logo_src"/></el-col></a>
        <el-col class="manu" :span="20">
          <el-menu :default-active="currentPage" class="el-menu" mode="horizontal" @select="handleSelect" text-color="#fff" active-text-color="#2b85e4"  background-color="#314555">
            <el-menu-item index="1"><i class="el-icon-s-home"></i>Home</el-menu-item>
            <!-- <el-menu-item index="2"> -->
            <el-submenu index="2">
              <template slot="title"><i class="el-icon-s-tools"></i>Analyze</template>
              <el-menu-item index="2-1">PCGA</el-menu-item>
              <el-menu-item index="2-2">EMIC</el-menu-item>
              <!-- <el-menu-item index="2-1">Infer relecant tissue & cell</el-menu-item> -->
              <!-- <el-menu-item index="2-2">Annotate cell cluster</el-menu-item> -->
            </el-submenu>
            <!-- </el-menu-item> -->
            <el-menu-item index="3"><i class="el-icon-search"></i>Search</el-menu-item>
            <el-menu-item index="4"><i class="el-icon-s-platform"></i>Browse</el-menu-item>
            <el-menu-item index="5"><i class="el-icon-document"></i>Help</el-menu-item>
            <el-menu-item index="6"><i class="el-icon-download"></i>Download</el-menu-item>
            <el-menu-item index="7"><i class="el-icon-s-custom"></i>Contact</el-menu-item>
            <!-- <el-button type="danger" @click="changeStyle">Style</el-button> -->
          </el-menu>
        </el-col>
      </el-row>
    </div>
  </div>

</template>

<script>
import spa_logo from '@/assets/img/logo_title1.png';
// import {current_page} from '@/bus.js'

export default {
  name: 'navi',
  props:["currentPage","naviHeight"],
  data () {
    return {
      logo_src:spa_logo,
      title:"Single-cell type and Phenotype cross Annotation framework",
      // activeIndex: "1",
      manuPath:{
        '1':'',
        '2-1':'infer_cell',
        '2-2':'emic',
        '3':'search',
        '4':'browse',
        '5':'document',
        '6':'download',
        '7':'contact',
      }
    }
  },

  methods:{
    navi_go:function(navi_iterm,event){
      this.$router.push({path:'/'+navi_iterm});
    },
    getHeight(){
      var odiv=document.getElementById('footer');
      var tpPos=odiv.getBoundingClientRect().top
      console.log(tpPos)
    },
    handleSelect(key) {
      // console.log(key);
      this.navi_go(this.manuPath[key])
    },
    initPage(){
      this.activeIndex=this.currentPage;
    },
    changeStyle(){
      var mainColor='#409EFF'
      document.querySelector('.footer,.navi,.el-menu,.func,.el-menu-item').style['background-color']=mainColor
      document.getElementsByClassName('el-menu el-menu--horizontal el-menu').style['background-color']=mainColor
    }
  },

  activated () {
      this.currentPage=this.currentPage;
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.navi{
  width: 100%;
  height: 60px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  /* position: fixed; */
}

.el-menu{
  border: 0;
}
.el-menu-item, .el-submenu{
  font-weight: 550;
  font-size: 15px;
}

.logo {
  height:70%;
}

.el-row{
  height: 100%;
}

.logo-div,.manu{
  height: 100%;
  display:flex;
  align-items: center;
}
.logo-div{
  justify-content: left;
}
.manu{
  justify-content: right;
}



</style>



// WEBPACK FOOTER //
// src/components/navigate.vue